var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cms-form',{attrs:{"post":_vm.currentCms,"loading":_vm.loading},on:{"submit":_vm.updatePost}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }